<!-- ACA EMPIEZA EL FORMULARIO -->
<div id="todoelformulario" class="col-lg-12">
    <h5 style="text-align: center; text-shadow: 1px 1px 2px lightslategrey;">Registrar un nuevo Gasto [{{proximo}}] <button *ngIf="userlog=='35363906'" class="btn-danger" (click)="llenarEjemplo()">++</button> <button *ngIf="userlog=='35363906'" (click)="guardarDetallitoPrueba()">aña</button> </h5>
    <br>
    <app-loading class="m-5" *ngIf="loading"></app-loading>

    <div class="jumbotron">
        <div id="encabezado">
            <label for="inputState">Motivo</label>
            <select [(ngModel)]="motivoPadre" name="motivoPadre" id="inputState" class="form-control" [disabled]="haydetalle">
                <option class="animated fadeIn fast" (click)="viaje==true; secc==false;">VIAJE</option>
                <option class="animated fadeIn fast" *ngIf="role=='AUTORIZADOR'" (click)="secc==true; viaje==false;">SECCIONAL</option>
                <option class="animated fadeIn fast" *ngIf="role=='AUTORIZADOR'" (click)="secc==true; viaje==false;">GASTOS OBRA SOCIAL</option>
                <option *ngIf="(role=='DELEGADO')" class="animated fadeIn fast">GASTOS DELEGACION</option>
            </select>
            <label for="inputDetail">Descripción</label>

            <input [(ngModel)]="detallePadre" name="detallePadre" type="text" class="form-control" id="inputDetail" maxLength="40">
            <label for="obs">Observaciones</label>
            <input [(ngModel)]="obsPadre" name="obsPadre" type="text" class="form-control" id="obs" placeholder="" maxLength="80">
            <div *ngIf="(role=='MULTI' && motivoPadre=='SECCIONAL') || (role=='AUTORIZADOR' && motivoPadre=='SECCIONAL') || (role=='PAGADOR' && motivoPadre=='SECCIONAL')">
                <label for="gasde">IMPUTACIÓN (PROPIO Ó TERCEROS--> INDICAR NOMBRE Y APELLIDO EN TAL CASO)</label>
                <input [(ngModel)]="gastoDePadre" name="gastoDePadre" value="PROPIO" type="text" class="form-control" id="gasde" placeholder="" maxLength="80">
                <!--
                <select [(ngModel)]="gastoDePadre" name="gastoDePadre" id="gasde" class="form-control">
                    <option *ngIf="role=='MULTI'"> PABLO PALACIO </option>
                    <option *ngIf="role=='MULTI'"> HUGO PALACIO </option>
                    <option *ngIf="role=='MULTI'"> MIGUEL RODRIGUEZ </option>
                    <option *ngIf="role=='MULTI'"> MIGUEL ROCA </option>
                    <option *ngIf="role=='MULTI'"> JORGE DELFINO </option>
                    <option *ngIf="role=='AUTORIZADOR'"> JUAN PEREZ </option>
                    <option *ngIf="role=='AUTORIZADOR'"> EJEMPLO 2 </option>
                    <option *ngIf="role=='AUTORIZADOR'"> EJEMPLO 3  </option>
                    <option *ngIf="role=='AUTORIZADOR'"> EJEMPLO 4 </option>
                     <option *ngIf="role=='AUTORIZADOR'"> OTRO </option>
                </select>
                -->
            </div>
        </div>

        <br *ngIf="haydetalle">

        <!-- CARDS PARA CELULAR -->
        <div class="card-columns" style="text-align:center; box-shadow: 0px 5px 3px #cccc;">
            <div class="card" *ngFor="let detail of dataSource.data" style="box-shadow: 5px 7px 20px #605f6b;">
                <br>
                <div style="text-align:center;">
                    <img id="fotocard" class="card-img-top img-fluid" src="{{ detail.imagen }}" alt="Card image cap">
                </div>
                <br>
                <div class="card-block">
                    <h5 class="card-title">"{{ dataSourceCategorias | categoryfilter: detail.categoria | uppercase}}"</h5>
                    <hr>
                    <p class="card-text">{{ detail.detalle | uppercase }}</p>
                    <p class="card-text">{{ detail.fecha_ticket | date: 'dd-MM-yyyy' | uppercase }}</p>
                    <p style="font-size: 16px" class="text-muted"><b> {{ detail.importe | currency:"$" }} </b></p>
                    <hr>
                    <div id="pie" style="text-align: center;">
                        <p style="font-size: 16px" class="text-muted"><b> ITEM {{ detail.i }} </b></p>
                        <button id="botonBorraModal" mat-icon-button color="accent" (click)="enviaItem(detail.i)" data-toggle="modal" data-target="#modalDelete">
                            <mat-icon aria-label="Delete">delete</mat-icon>
                        </button>
                    </div>

                </div>
            </div>
        </div>

        <br>

        <div id="tablita">
            <div *ngIf="haydetalle" id="mostrarTabla">

                <table *ngIf="haydetalle && registros>=1" mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                    <!-- id Column -->
                    <ng-container matColumnDef="i">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> id. </th>
                        <td mat-cell *matCellDef="let element"> {{element.i}} </td>
                    </ng-container>
                    <!-- Position Column -->
                    <ng-container matColumnDef="cod_gasto">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> COD GASTO. </th>
                        <td mat-cell *matCellDef="let element"> {{element.cod_gasto}} </td>
                    </ng-container>
                    <!-- Name Column -->
                    <ng-container matColumnDef="fecha_ticket">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA TICKET </th>
                        <td mat-cell *matCellDef="let element"> {{element.fecha_ticket | date: 'dd-MMMM-yyyy' | uppercase}} </td>
                    </ng-container>
                    <!-- Weight Column -->
                    <ng-container matColumnDef="detalle">
                        <th style="padding-left: 15px;" mat-header-cell *matHeaderCellDef mat-sort-header> DETALLE </th>
                        <td style="padding-left: 15px;" mat-cell *matCellDef="let element"> {{element.detalle | uppercase}} </td>
                    </ng-container>
                    <!-- Symbol Column -->
                    <ng-container matColumnDef="importe">
                        <th style="text-align: center" mat-header-cell *matHeaderCellDef mat-sort-header> IMPORTE </th>
                        <td style="text-align: center" mat-cell *matCellDef="let element"> {{element.importe | currency:"$" }} </td>
                    </ng-container>
                    <!-- Symbol Column -->
                    <ng-container matColumnDef="categoria">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> CATEGORIA </th>
                        <td mat-cell *matCellDef="let element"> {{dataSourceCategorias | categoryfilter: element.categoria | uppercase}}
                        </td>
                    </ng-container>
                    <!-- Symbol Column -->
                    <ng-container matColumnDef="imagen">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> IMAGEN </th>
                        <td mat-cell *matCellDef="let element"> <img style="width: 30px; height: 30px;" src="{{element.imagen}}">
                        </td>
                    </ng-container>
                    <!-- borrar Column -->
                    <ng-container matColumnDef="x">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Borrar </th>
                        <td mat-cell *matCellDef="let element">
                            <button hidden id="botonBorra" mat-icon-button color="accent" (click)="removeAt(element.i)">
                                <mat-icon aria-label="Delete">delete</mat-icon>
                            </button>
                            <button id="botonBorraModal" mat-icon-button color="accent" (click)="enviaItem(element.i)" data-toggle="modal" data-target="#modalDelete">
                                <mat-icon aria-label="Delete">delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr class="table-header" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>

            <br>
            <div style="text-align: center">
                <!-- Boton trigger modal completa formulario -->
                <button *ngIf="haydetalle && registros>=1 && role!='USER'" type="button" class="btn btn-success" data-toggle="modal" data-target="#MODALGUARDAR" [disabled]="(!detallePadre) || (!motivoPadre) ">
                    ENVIAR FORMULARIO ({{items}} items, {{ parcial | currency:"$" }})
                </button>
                <button *ngIf="haydetalle && registros>=1 && role=='USER'" type="button" class="btn btn-success" data-toggle="modal" data-target="#MODALFIN" [disabled]="(!detallePadre) || (!motivoPadre) ">
                        ENVIAR FORMULARIO2
                </button>
            </div>

        </div>
    </div>

    <div id="divformu">
        <div id="formu" [formGroup]="detallito" (ngSubmit)="guardarDetallito()" style="background-color: #f8f9fa99;">
            <div id="datoscarga">
                <div class="example-container">
                    <!--
                    {{ detallito.valid }}
                    -->
                    <mat-form-field>
                        <mat-select formControlName="categoria" placeholder="Seleccione Categoría">
                            <mat-option *ngFor="let cat of dataSourceCategorias;" [value]="cat.codysub">
                                {{ cat.detalle | uppercase}} ({{cat.codigo}}-{{cat.sub_codigo}})
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!--
                    <mat-form-field>
                        <mat-select formControlName="categoria" placeholder="Seleccione Categoría">
                            <mat-option *ngIf="motivoPadre=='VIAJE'" value="COMIDA">COMIDA</mat-option>
                            <mat-option *ngIf="motivoPadre=='VIAJE'" value="COMBUSTIBLE">COMBUSTIBLE</mat-option>
                            <mat-option *ngIf="motivoPadre=='VIAJE'" value="PEAJE">PEAJE</mat-option>
                            <mat-option *ngIf="motivoPadre=='VIAJE'" value="HOSPEDAJE">HOSPEDAJE</mat-option>
                            <mat-option *ngIf="motivoPadre=='VIAJE'" value="TAXI">TAXI</mat-option>
                            <mat-option *ngIf="motivoPadre=='VIAJE'" value="TRANSPORTE">TRANSPORTE</mat-option>
                            <mat-option *ngIf="motivoPadre=='VIAJE'" value="MECANICO">MECANICO</mat-option>
                            <mat-option *ngIf="motivoPadre=='VIAJE'" value="MECANICO">SERVICIO DE ENCOMIENDA</mat-option>
                            <mat-option *ngIf="motivoPadre=='SECCIONAL'" value="ELECTRICIDAD">ELECTRICIDAD</mat-option>
                            <mat-option *ngIf="motivoPadre=='SECCIONAL'" value="AGUA">AGUA</mat-option>
                            <mat-option *ngIf="motivoPadre=='SECCIONAL'" value="GAS">GAS</mat-option>
                            <mat-option *ngIf="motivoPadre=='SECCIONAL'" value="IMPUESTO INMOBILIARIO">IMPUESTO INMOBILIARIO</mat-option>
                            <mat-option *ngIf="motivoPadre=='SECCIONAL'" value="ALQUILER">ALQUILER</mat-option>
                            <mat-option *ngIf="motivoPadre=='SECCIONAL'" value="COMIDA">COMIDA</mat-option>
                            <mat-option *ngIf="motivoPadre=='SECCIONAL'" value="OTROS">OTROS</mat-option>
                        </mat-select>    
                    </mat-form-field>
                    -->
                    <mat-form-field>
                        <textarea formControlName="detalle" matInput placeholder="Descripcion del sub-gasto" maxLength="35"></textarea>
                    </mat-form-field>

                    <mat-form-field>
                        <input formControlName="fecha_ticket" matInput [matDatepicker]="picker" placeholder="Fecha Ticket" [value]="dateValue" (dateInput)="addEvent('input', $event)">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>

                    <div>
                        <mat-form-field>
                            <input onClick="this.select();" name="imim" [(ngModel)]="imim" formControlName="importe" type="number" matInput placeholder="Importe: ({{ strsumi }})" maxLength="8">
                        </mat-form-field>
                        <button mat-icon-button color="danger" (click)="add()">
                            <mat-icon aria-label="add">add</mat-icon>
                        </button>
                        <button mat-icon-button color="danger" (click)="refresh()">
                            <mat-icon aria-label="print">refresh</mat-icon>
                        </button>
                        <button mat-icon-button color="danger" (click)="done()">
                            <mat-icon aria-label="print">done</mat-icon>
                        </button>
                    </div>
                    

                    <div *ngIf="fotodetalle" style="height: 250px; width: 300px; text-align: center;" class="container">
                        <img id="ima" *ngIf="fotodetalle" src="{{fotodetalle}}" />
                        <p class="title">IMAGEN A SUBIR</p>
                        <div style="height: 250px; width: 300px; text-align: center;" class="overlay"></div>
                        <div class="button"><a style="cursor: pointer" (click)="quitarImagen()"> Quitar Imagen </a></div>
                    </div>
                    <div style="text-align: center;">
                        <button style="height: 60px;" *ngIf="!fotodetalle" type="button" class="btn btn-secondary dropdown-toggle" data-toggle="modal" data-target="#modalImagen">
                            Subir Imagen
                        </button>
                    </div>

                </div>
            </div>
            <hr>

            <button style="height: 90px;" (click)="guardarDetallito(); getProximo(); limpiacam();" type="button" class="btn btn-success btn-block" [disabled]="!detallito.valid">  
                AÑADIR TICKET/GASTO (Completado)
            </button>

        </div>

        <hr>

        <button type="button" data-toggle="modal" data-target="#MODALSALIR" class="btn btn-danger btn-block">  
                CANCELAR (Salir)
        </button>
    </div>
    <!--
    <button (click)="guardarDetallitoPrueba()">+++</button>
    -->
</div>




<!--                        MODALES                          -->

<!-- Modal confirma eliminar item -->
<div style="margin-top: 280px" class="modal fade" id="modalDelete" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modalito2" class="modal-content">

            <div class="modal-body">
                ¿Eliminar item {{temporal}}?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
                <button data-dismiss="modal" (click)="removeAt(temporal)" type="button" class="btn btn-primary">ELIMINAR</button>
            </div>
        </div>
    </div>
</div>


<!-- Modal COMPLETAR FORMULARIO -->
<div style="margin-top: 60px" class="modal fade" id="MODALFIN" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modalito2" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Carga Completa</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                ¿Esta seguro que completó el proceso de carga de gastos?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
                <button data-dismiss="modal" (click)="enviarFormulario()" type="button" class="btn btn-primary">Finalizar</button>
            </div>
        </div>
    </div>
</div>


<!-- Modal GUARDAR O FINALIZAR GASTO -->
<div style="margin-top: 60px" class="modal fade" id="MODALGUARDAR" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modalito2" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">¿QUE DESEA HACER?</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                ELIJA OPCION
                <div id="guadaofinaliza">
                    <br>
                    <mat-radio-group aria-label="Estado" [(ngModel)]="estPadre">
                        <mat-radio-button value="PENDIENTE"><b>GUARDAR</b> (NO VA A TESORERÍA)</mat-radio-button>
                        &nbsp;
                        <mat-radio-button value="AUTORIZADO"> <b>FINALIZAR</b> (ENVIAR A TESORERÍA)</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="modal-footer" style="text-align: center">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
                <button data-dismiss="modal" (click)="enviarFormulario()" type="button" class="btn btn-primary">Finalizar</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal SALIR -->
<div style="margin-top: 60px" class="modal fade" id="MODALSALIR" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modalito2" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">CANCELAR NUEVO GASTO</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
            </div>
            <div class="modal-body">
                ¿Esta seguro que desea cancelar la carga del gasto? (Los datos no enviados pueden perderse)
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                <button data-dismiss="modal" routerLink="/home" type="button" class="btn btn-primary">SALIR!</button>
            </div>
        </div>
    </div>
</div>



<!-- Modal Subir imagen desde pc-->
<div class="modal fade" id="modalsubir" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modalito" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Acción</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <div>
                    <input id="botonsubirarchivo" type="file" accept="image/*" class="form-control browse" ngModel (change)="getFiles($event)">
                    <br>
                </div>
                <div style="text-align: center; width:300; height:200px" *ngIf="fotob64">
                    <img id="imasubida" style="width:300px; height:200px" src="{{fotob64}}">
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                <button (click)="snackCamara(); subirImagenDesdePc();" type="button" class="btn btn-primary" data-dismiss="modal" [disabled]="!fotob64">Subir Imagen </button>
            </div>
        </div>
    </div>
</div>


<!-- Modal captura webcam (pc) -->
<div style="overflow-y: scroll;" class="modal fade" id="modalcaptura" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modalcap" class="modal-content">
            <div hidden class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">CAPTURE CON SU WEBCAM</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="text-align: center">
                <div>
                    <div>
                        <webcam id="webcamm" [height]="400" [width]="400" [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
                            (initError)="handleInitError($event)">
                        </webcam>
                    </div>
                    <button style="height:100px; margin-left: 30px;" class="actionBtn btn btn-info btn-block" type="button" id="snap" (click)="triggerSnapshot(); snackCamara();" data-dismiss="modal">***CAPTURAR***</button>
                </div>
                <!-- lo quito temporalmente (muestra la foto que saque)
                <div class="snapshot animated fadeIn" *ngIf="webcamImage">
                    <h6>Imagen capturada</h6>
                    <img class="animated fadeIn" id="imacapturada" [src]="webcamImage.imageAsDataUrl" />
                </div>

                <h4 *ngIf="errors.length > 0">Messages:</h4>
                <ul *ngFor="let error of errors">
                    <li>{{error | json}}</li>
                </ul>
            -->
                <!--
                    <video #video id="video" width="320" height="240" autoplay style="display:none"></video>
                    
                    <webcam width="320" height="240"></webcam>
                </div>
                <div style="text-align: center;">
                    <button style="height: 60px;" class="btn btn-secondary" type="button" id="snap" (click)="capture()">¡CAPTURAR!</button>
                </div>
                <hr>
                <div style="text-align: center">
                    <canvas #canvas id="canvas" width="640" height="480"></canvas>
                    <ul>
                        <div style="text-align: center">
                            <li *ngFor="let c of captures">
                                <img id="ulcaptura" src="{{ c }}" height="100px" />
                            </li>
                        </div>

                    </ul>
                </div>
            -->
            </div>
            <!--
            <div class="modal-footer" style="text-align: center;">
                <span>
                    <button (click)="limpiacam()" type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button (click)="snackCamara()" type="button" class="btn btn-primary" data-dismiss="modal" [disabled]="!fotodetalle">Guardar Captura </button>
                </span>
            </div>
        -->
        </div>
    </div>
</div>


<!-- Modal IMAGEN elije captura o subir -->
<div class="modal fade" id="modalImagen" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modalito" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">ELIJA OPCIÓN</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <div id="tieneimagen">
                    <span id="botonsubes" class="efectoFoto" *ngIf="userlog != '28933205'">
                        <input id="botonsube" style="height: 179px; width: 226px" data-dismiss="modal" type="image" name="foto" ng2FileSelect [uploader]="uploader" class="btn btn-primary" data-toggle="modal" data-target="#modalsubir" src="../../../assets/img/camara.png" >
                    </span>
                    <span id="patroncoso" *ngIf="userlog == '28933205'">
                        <input id="patroncoso2" style="height: 179px; width: 226px" data-dismiss="modal" type="image" name="foto" ng2FileSelect [uploader]="uploader" class="btn btn-primary" data-toggle="modal" data-target="#modalsubir" src="../../../assets/img/camara.png" >
                    </span>
                    <span>&nbsp;</span>
                    <span id="botoncaptura" (click)="prendeCamara()" data-dismiss="modal" type="button" class="efectoFoto btn btn-primary" data-toggle="modal" data-target="#modalcaptura">
                        <img style="height: 165px; width: 200px" src="../../../assets/img/camaraa.png" >
                    </span>
                </div>
            </div>
            <div class="modal-footer" style="text-align: center; display: block;">
                <button (click)="apagaCamara()" type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            </div>
        </div>
    </div>
</div>